import React from "react";
// import CookieBanner from "./cookieBanner";

function FooterPart() {
  const currentYear = new Date().getFullYear();
  var footer = (
	<>
		<footer className="pt-3 bg-white position-relative z-1">
		<div className="container-fluid kn-footer">
			<div className="container">
			<div className="row">
				<div className="col-sm-4 d-flex kn-footer-logos">
					<a href={window.REACT_APP_ROUTER_BASENAME} className="navbar-brand">
						<img src="public/images/shared/footer-logo.png" />
					</a>
				</div>
				<div className="col-sm-8 kn-footer-address">
				<div className="kn-address d-flex align-items-end flex-column">
					<ul className="list-unstyled text-sm-end">
					<li className="text-primary">
						<strong>
						Konica Minolta Business Solutions, U.S.A., Inc
						</strong>
					</li>
					<li>
						<strong>100 Williams Drive</strong>
					</li>
					<li>
						<strong>Ramsey, NJ 07446</strong>
					</li>
					<li>
						<strong><a href="mailto:collect@cleanplanetprogram.com">collect@cleanplanetprogram.com</a></strong>
					</li>
					</ul>
				</div>
				</div>
			</div>
			</div>
		</div>
			<div className="container-fluid kn-footer-bottom">
				<div className="container">
					<div className="row kn-footer-bottom-low">
						<div className="col-md-6 ">
							<div className="kn-copy  text-center text-md-start">
								<small>
									<span>© {currentYear} Konica Minolta Business Solutions U.S.A., Inc.</span>
									<br className="d-block d-lg-none"/>
									<span>
										<span className="d-none d-lg-inline">|</span> Powered by{" "}
										<a
											className="text-nav"
											target="_blank"
											href="https://www.cloverimaging.com/">
											Clover Imaging Group
										</a>
									</span>
								</small>
							</div>
						</div>
						<div className="col-md-6">
							<div className="kn-footer-links">
								<ul className="list-unstyled list-horizontal text-center text-md-end mt-2 mt-md-0">
									<li className="list-inline-item">
										<a
											className="link-primary"
											href={
												window.REACT_APP_ROUTER_BASENAME + "/privacy-policy"
											}>
											<strong>Privacy Policy</strong>
										</a>
									</li>
									<li className="list-inline-item">
										<a
											href={window.REACT_APP_ROUTER_BASENAME + "/terms-of-use"}
											className="link-primary">
											<strong>Terms and Conditions</strong>
										</a>
									</li>
									<li className="list-inline-item">
										<a href="#" className="termly-display-preferences link-primary"><strong>Consent Preferences</strong></a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	</>
  );

  return footer;
}

export default FooterPart;
